import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLegs = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 90,
	height: 89,
	viewBox: "0 0 90 89",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M45.0019 24.7223L48.7623 4.64991L59.0709 3.53125L53.2574 34.5628L56.4415 38.3583L57.4904 38.2445L57.5686 38.3381L57.9531 38.0169L64.8167 46.2304L65.4164 46.1653L68.8357 50.0092C70.3238 49.7484 71.5792 49.9865 72.1465 50.7618L72.1903 50.8248C72.6413 51.5091 72.4934 52.4574 71.8844 53.4364L74.2534 56.0995C79.3526 56.1003 83.5587 57.7109 85.3821 60.4129L85.668 60.3214C85.7697 60.6939 85.859 61.0664 85.9356 61.438C86.1003 61.8353 86.219 62.251 86.2877 62.6842C86.3868 63.3098 86.3771 63.9425 86.2682 64.5745C86.2707 70.0107 83.1069 74.9246 75.2264 77.4503C66.9629 80.0986 57.3468 77.3695 55.0502 70.7811C54.7911 70.2693 54.6115 69.724 54.5202 69.148C54.4978 69.0069 54.4813 68.8653 54.4699 68.7235L54.3996 68.7311L54.3143 67.9445L54.2994 67.9383C54.3031 67.9295 54.307 67.9207 54.3107 67.9119L53.396 59.4826C52.6944 59.1118 52.2183 58.6148 52.0769 58.026L52.0608 57.9508C51.9282 57.2491 52.2925 56.5379 53.0099 55.9244L52.5326 51.5266L48.3854 69.6749L49.4191 69.5627L48.0361 74.9818L7.74332 79.3543L9.12613 73.9352L10.2681 73.8113L11.2209 69.5446C12.8145 62.4096 18.7739 57.0808 26.042 56.2921C28.8593 55.9864 31.4835 56.7139 33.6062 58.1286L34.512 54.1649C33.2395 54.2758 31.3314 54.1961 29.7955 53.087L29.7355 53.0431C27.1856 51.1448 25.8164 48.4669 26.6773 47.0621L26.719 46.9975C27.6245 45.6701 30.343 46.087 32.853 47.9557L32.9124 48.0004C34.0144 48.846 34.7276 50.1007 35.1807 51.239L35.601 49.4002L37.8346 49.1578L37.8338 49.1577L37.5241 49.0861L39.6047 40.0785L39.916 40.1504L42.1573 39.9072L43.0903 34.9267L20.1042 7.1742L29.4313 6.16204L45.0019 24.7223ZM70.9537 52.3901C71.2277 51.7861 71.1104 51.4908 71.0566 51.4172C70.9981 51.3373 70.7028 51.0929 69.8309 51.128L70.9537 52.3901ZM29.0112 47.5823C28.0562 47.4442 27.7531 47.7305 27.6973 47.8215C27.6416 47.9123 27.5137 48.3294 27.9866 49.2543C28.4257 50.113 29.2543 51.1058 30.4 51.9587C31.3673 52.6789 32.6122 52.8905 33.7261 52.8779C33.9808 52.875 34.2204 52.86 34.4378 52.8395C34.3739 52.6095 34.297 52.3589 34.2043 52.0974C33.7989 50.9537 33.1558 49.7601 32.1886 49.04C31.0428 48.187 29.8979 47.7106 29.0112 47.5823Z",
			fill: "#002938"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M37.836 49.1583L52.0433 47.6166L54.124 38.609L39.9167 40.1507L37.836 49.1583Z",
			fill: "#4EA4BD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M42.1576 39.9089L52.4661 38.7902L59.0713 3.53154L48.7628 4.6502L42.1576 39.9089Z",
			fill: "#002938"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M46.6555 48.0958L48.7361 39.0881L49.3557 39.2313L47.275 48.2389L46.6555 48.0958Z",
			fill: "#002938"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M52.0086 47.5208L54.0893 38.5131L54.6743 38.6483L52.5936 47.6559L52.0086 47.5208Z",
			fill: "#002938"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M37.5246 49.0865L39.6052 40.0789L40.2249 40.222L38.1441 49.2296L37.5246 49.0865Z",
			fill: "#002938"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M42.028 48.598L44.1086 39.5903L44.7283 39.7335L42.6476 48.7411L42.028 48.598Z",
			fill: "#002938"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M48.2485 70.2756L30.3879 72.2138L35.6014 49.4007L53.462 47.4625L48.2485 70.2756Z",
			fill: "#06748D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M38.1859 71.3676L10.1349 74.4117L11.2218 69.545C12.8154 62.41 18.7748 57.0813 26.0429 56.2926Lnan nanL26.0429 56.2926Lnan nanL26.0429 56.2926C33.8418 55.4463 40.1629 62.5156 38.453 70.1716L38.1859 71.3676Z",
			fill: "#06748D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32.1887 49.0407C31.043 48.1877 29.898 47.7113 29.0113 47.583C28.0564 47.4448 27.7532 47.7312 27.6975 47.8221C27.6418 47.913 27.5139 48.33 27.9868 49.2549C28.4259 50.1137 29.2545 51.1064 30.4002 51.9594C31.3675 52.6795 32.6123 52.8912 33.7262 52.8785C33.9809 52.8756 34.2206 52.8608 34.438 52.8402C34.3741 52.6102 34.2971 52.3596 34.2044 52.0981C33.7991 50.9544 33.156 49.7608 32.1887 49.0407ZM35.5768 52.6529C35.5767 52.6529 35.5764 52.6529 35.576 52.653C35.5757 52.6531 35.5754 52.6532 35.5751 52.6533L35.5768 52.6529ZM32.9126 48.0012C35.4065 49.9147 35.9096 53.9227 35.9115 53.9371L35.8701 53.948C35.4659 54.0506 32.1817 54.8106 29.7957 53.0877L29.7357 53.0437C27.1858 51.1454 25.8165 48.4676 26.6774 47.0627L26.7191 46.9982C27.6246 45.6707 30.3431 46.0877 32.8531 47.9563L32.9126 48.0012Z",
			fill: "#002938"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M40.1587 56.4206C41.5448 56.7656 42.7848 56.7634 43.6524 56.5397C44.5867 56.2988 44.7559 55.9176 44.7723 55.8122C44.7886 55.7069 44.7458 55.2728 43.9526 54.6019C43.2162 53.9791 42.0688 53.3828 40.6827 53.0379C39.5125 52.7467 38.2824 53.0316 37.2596 53.473C37.0257 53.5739 36.8103 53.6801 36.6177 53.7829C36.7654 53.9705 36.933 54.172 37.1194 54.3775C37.9346 55.2763 38.9884 56.1294 40.1587 56.4206ZM35.6393 54.3951C35.6394 54.395 35.6397 54.3949 35.64 54.3946C35.6402 54.3945 35.6404 54.3943 35.6407 54.394L35.6393 54.3951ZM39.8918 57.6589C36.8528 56.8556 34.8423 53.3519 34.8351 53.3393L34.869 53.3134C35.2024 53.0628 37.9392 51.0946 40.8052 51.7637L40.8774 51.7811C43.9623 52.5488 46.2586 54.4911 46.0064 56.1193L45.9928 56.195C45.6695 57.7689 43.0006 58.433 39.964 57.6774L39.8918 57.6589Z",
			fill: "#002938"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M48.0366 74.9824L7.74378 79.3549L9.12664 73.9357L49.4195 69.5632L48.0366 74.9824Z",
			fill: "#002938"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M33.6969 58.1104C37.7933 59.8631 38.8131 64.1487 38.8193 66.063L38.1834 66.0651C38.1777 64.2729 37.209 60.3047 33.4467 58.695L33.6969 58.1104Z",
			fill: "#002938"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.1403 61.8101C22.6178 59.8183 25.4355 59.2104 26.4338 60.4522C27.4321 61.694 26.233 64.3153 23.7555 66.307C21.2779 68.2987 18.4602 68.9066 17.4619 67.6648C16.4636 66.423 17.6628 63.8018 20.1403 61.8101Z",
			fill: "#4EA4BD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.04 62.7733C27.0019 62 28.0958 61.764 28.4834 62.2461C28.871 62.7283 28.4055 63.746 27.4436 64.5193C26.4817 65.2926 25.3877 65.5286 25.0001 65.0465C24.6125 64.5643 25.0781 63.5466 26.04 62.7733Z",
			fill: "#4EA4BD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.4319 6.16215L20.1047 7.17432L55.4755 49.8797L65.2204 48.8222L29.4319 6.16215Z",
			fill: "#06748D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M57.4908 38.2447L45.1785 39.5808L54.0996 50.0291L66.2376 48.7119L57.4908 38.2447Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M62.6454 48.9238L62.1574 49.3316L53.4106 38.8643L53.8985 38.4566L62.6454 48.9238Z",
			fill: "#002938"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M58.5909 49.3643L58.103 49.772L49.3562 39.3047L49.8441 38.897L58.5909 49.3643Z",
			fill: "#002938"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M66.7003 48.4846L66.2124 48.8923L57.4655 38.4251L57.9535 38.0174L66.7003 48.4846Z",
			fill: "#002938"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M54.5375 49.804L54.0495 50.2117L45.3027 39.7444L45.7906 39.3367L54.5375 49.804Z",
			fill: "#002938"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M52.1079 47.6101L65.4167 46.1659L82.7534 65.6548L54.4 68.7317L52.1079 47.6101Z",
			fill: "#4EA4BD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M57.3731 55.5277C55.9598 55.7347 54.8134 56.2074 54.0957 56.7437C53.3227 57.3212 53.3108 57.7381 53.3357 57.8418C53.3606 57.9454 53.565 58.3308 54.5535 58.6503C55.4712 58.9471 56.759 59.0632 58.1723 58.8562C59.3655 58.6814 60.3954 57.9509 61.1741 57.1543C61.3522 56.9721 61.5111 56.7921 61.6503 56.6238C61.4425 56.5064 61.2109 56.3836 60.9604 56.2643C59.8651 55.7422 58.5663 55.3529 57.3731 55.5277ZM62.3231 55.6861C62.323 55.6862 62.3228 55.6864 62.3226 55.6868C62.3225 55.687 62.3224 55.6873 62.3222 55.6876L62.3231 55.6861ZM57.1499 54.2808C60.2664 53.8704 63.4562 56.3486 63.4679 56.3576L63.4463 56.3945C63.233 56.7529 61.4481 59.6126 58.5427 60.0815L58.4692 60.0927C55.3238 60.5535 52.4621 59.6282 52.0774 58.0261L52.0613 57.951C51.7629 56.3721 53.98 54.7446 57.0762 54.2911L57.1499 54.2808Z",
			fill: "#002938"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M68.2253 55.1097C69.4493 54.3735 70.3247 53.4951 70.7799 52.7234C71.2702 51.8924 71.1204 51.5032 71.0574 51.4171C70.9945 51.3311 70.6572 51.0545 69.622 51.1409C68.6609 51.2212 67.4279 51.6109 66.2039 52.3471C65.1705 52.9687 64.5022 54.04 64.091 55.0753C63.997 55.3121 63.9198 55.5394 63.8563 55.7484C64.0933 55.7766 64.3544 55.8005 64.6315 55.814C65.8435 55.8731 67.1919 55.7312 68.2253 55.1097ZM68.9122 56.1739C66.1952 57.7549 62.2962 56.699 62.2822 56.6952L62.2878 56.6528C62.3463 56.2399 62.8898 52.913 65.3895 51.3595L65.4529 51.3208C68.1771 49.6823 71.1743 49.432 72.1472 50.7616L72.1911 50.8247C73.0754 52.1663 71.6578 54.5231 68.9763 56.136L68.9122 56.1739Z",
			fill: "#002938"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M75.2268 77.4503C85.128 74.2771 87.5836 67.3339 85.6684 60.3214L54.8677 70.1929C56.7828 77.2053 66.7215 80.1762 75.2268 77.4503Z",
			fill: "#06748D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M86.288 62.6842C87.0991 67.802 80.6453 73.3978 71.8729 75.1828C63.1006 76.9677 55.3316 74.2658 54.5205 69.148C53.7093 64.0302 60.1632 58.4344 68.9355 56.6495C77.7079 54.8645 85.4768 57.5664 86.288 62.6842Z",
			fill: "#4EA4BD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M75.7413 58.5831C78.9016 58.9266 81.3238 60.4892 81.1517 62.0731C80.9795 63.6571 78.278 64.6628 75.1178 64.3192C71.9576 63.9757 69.5353 62.4132 69.7075 60.8292C69.8797 59.2452 72.5811 58.2396 75.7413 58.5831Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M64.8001 58.2536C68.1436 56.7689 71.5167 56.1297 74.4636 56.2715L74.4153 56.9165C71.5734 56.7797 68.2962 57.3962 65.0326 58.8454C60.0659 61.0509 56.3808 64.6282 54.872 68.1819L54.2998 67.9382C55.8915 64.1892 59.7249 60.5072 64.8001 58.2536Z",
			fill: "#002938"
		})
	]
});
const ForwardRef = forwardRef(SvgLegs);
export default ForwardRef;
